export default __webpack_public_path__ + "8e9dc14293857c6af924dbcb238fe8b4.png";